import { Link } from 'react-router-dom';

export function AgencyBrand({ compact = false, publicSite = false, refreshCurrent = false }: { compact?: boolean; publicSite?: boolean; refreshCurrent?: boolean }) {
  const content = <img
    className={compact ? 'agency-logo' : 'agency-lockup'}
    src={compact ? '/brand/auri79-crest.png' : '/brand/auri79-lockup.png'}
    alt=""
    decoding="async"
  />;
  if (refreshCurrent) return <a className="agency-brand" href={`${window.location.pathname}${window.location.search}${window.location.hash}`} aria-label="Refresh this website preview">{content}</a>;
  if (publicSite) return <a className="agency-brand" href={import.meta.env.VITE_AGENCY_SITE_URL ?? 'https://auri79.com'} aria-label="Visit the Auri79 website">{content}</a>;
  return <Link className="agency-brand" to="/admin" aria-label="Auri79 admin dashboard">{content}</Link>;
}
